module.exports = __webpack_public_path__ + "img/08-JS-make-your-resume-and-cover-letter-shine.6e94a985.svg";